/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ErpProvisioningRequestPostSpec { 
    tenantID?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    saasTransactionID: string;
    action?: string;
    sku?: string;
    serialNumber?: string;
    quantity?: string;
    subscriptionType?: string;
    pla?: string;
    serviceStartDate?: string;
    serviceEndDate?: string;
    erpCustAcctNumber?: string;
    countryCode?: string;
    newTenantRequired?: string;
    information?: string;
}

